import React, { Component } from "react";

import {
  CBreadcrumb,
  CBreadcrumbItem,
  CCol,
  CLink,
  CRow,
  CWidgetStatsB
} from "@coreui/react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Breadcrumb } from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setLayout } from "../../../../actions/layoutActions";
import { setObj } from "../../../../actions/noteActions";
import EvaluationBankDashboardItem from "../../../../components/EvaluationBankDashboardItem/EvaluationBankDashboardItem";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import { TrailDashBoardItem } from "../../../../components/TrailDashboardItem";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

class EvaluationBankStudentStatistics extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      evaluations: undefined,
      user_id: this.props.match.params.id,
      userData: undefined,
      infoUser: null
    };
  }

  componentDidMount() {
    let infoUser = {
      group: null,
      region: null,
      school: null,
      room: null,
      user: null
    };

    (async () => {
      await axios
        .get(
          `${URL.api}activity/allocations/listByUser/${this.state.user_id}`,
          {
            headers: { Authorization: `Bearer ${this.props.user.token}` }
          }
        )
        .then(resp => {
          this.setState({ evaluations: resp.data.data });
        });
      await axios
        .get(`${URL.api}access/user/singleView/${this.state.user_id}`, {
          headers: { Authorization: `Bearer ${this.props.user.token}` }
        })
        .then(resp => {
          infoUser.group = resp.data.data.user_role[0].group_id;
          infoUser.region = resp.data.data.user_role[0].region_id;
          infoUser.school = resp.data.data.user_role[0].school_id;
          const findedRoom = resp.data.data.user_rooms.find(room =>
            this.isCurrentDateBetween(room.start, room.room.end)
          );
          infoUser.room = findedRoom?.room_id;
          infoUser.user = resp.data.data.user.id;

          this.setState({ userData: resp.data.data, loading: false, infoUser });
        });
    })();
  }

  isCurrentDateBetween(startString, endString) {
    // Converte as strings para objetos Date
    const startDate = new Date(startString);
    const endDate = new Date(endString);

    // Obtém a data atual
    const currentDate = new Date();

    // Verifica se a data atual está entre start e end
    return currentDate >= startDate && currentDate <= endDate;
  }

  render() {
    return (
      <div className="summary-student-main-content">
        {this.state.loading ? (
          <Loading />
        ) : (
          <>
            <CBreadcrumb className="w-100 p-0 border-0">
              <CBreadcrumbItem>
                <CLink to="/dashboard">Menu Inicial</CLink>
              </CBreadcrumbItem>
              <CBreadcrumbItem active>
                <span>Estatísticas do Estudante</span>
              </CBreadcrumbItem>
            </CBreadcrumb>
            <CRow className="summary-student-header-content">
              <CCol
                md="2"
                sm="12"
                className="d-flex justify-content-center align-items-center"
              >
                <img
                  src={`${URL.img}${
                    this.state.userData.user.photo ||
                    "uploads/users/profileEmpty.jpg"
                  }`}
                  className="summary-student-pic"
                />
              </CCol>
              <CCol sm="10">
                <CRow className="d-flex flex-column">
                  <h2 className="summary-student-header-name">
                    {this.state.userData.user.name || "Não informado"}
                  </h2>
                  <h3 className="summary-student-header-email">
                    {this.state.userData.user.email || "Não informado"}
                  </h3>
                </CRow>
                <CRow className="mt-3">
                  <CCol md="3" sm="12" className="p-0">
                    <h3 className="summary-student-header-item-title">
                      Login:
                    </h3>
                    <h4 className="summary-student-header-item-content">
                      {this.state.userData.user.username || "Não informado"}
                    </h4>
                  </CCol>
                  <CCol md="3" sm="12" className="p-0">
                    <h3 className="summary-student-header-item-title">
                      Nascimento:
                    </h3>
                    <h4 className="summary-student-header-item-content">
                      {this.state.userData.user_complement.birthday ||
                        "Não informado"}
                    </h4>
                  </CCol>
                  <CCol md="3" sm="12" className="p-0">
                    <h3 className="summary-student-header-item-title">
                      Telefone:
                    </h3>
                    <h4 className="summary-student-header-item-content">
                      {this.state.userData.user.phone || "Não informado"}
                    </h4>
                  </CCol>
                  <CCol md="3" sm="12" className="p-0">
                    <h3 className="summary-student-header-item-title">
                      Genero:
                    </h3>
                    <h4 className="summary-student-header-item-content">
                      {this.state.userData.user_complement.gender ||
                        "Não informado"}
                    </h4>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
            <div className="summary-student-evaluationprogress mt-5">
              <h2 className="summary-student-evaluationprogress-title">
                Avaliações atuais
              </h2>
              <CRow>
                {this.state.evaluations.length ? (
                  <>
                    {this.state.evaluations?.map((evaluation, index) => (
                      <CCol md="6" sm="12">
                        <EvaluationBankDashboardItem
                          key={index}
                          title={evaluation.name}
                          activityId={evaluation.activity_id}
                          infoUser={this.state.infoUser}
                          progress={
                            evaluation.completion_percentage
                              ? evaluation.completion_percentage
                              : 0
                          }
                        />
                      </CCol>
                    ))}
                  </>
                ) : (
                  <div className="d-flex w-100 align-items-center justify-content-center mt-5">
                    Nenhuma avaliação encontrada.
                  </div>
                )}
              </CRow>
            </div>
          </>
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </div>
    );
  }
}

EvaluationBankStudentStatistics.propTypes = {
  hideLayout: PropTypes.bool,
  guestLogin: PropTypes.bool
};

EvaluationBankStudentStatistics.defaultProps = {
  hideLayout: false,
  guestLogin: false
};

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj,
      setLayout
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EvaluationBankStudentStatistics);
